import React, { useState } from 'react';

import { useSnackbar } from 'notistack';

import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import ErrorListDisplay from '~/components/Common/ErrorListDisplay';
import Spinner from '~/components/Common/Spinner';

import { useResendVCCConfirmation } from '~/hooks/apis/reservations/useResendVCCConfirmation';

interface Props {
  isModalVisible: boolean;
  hideModal: () => void;
  bookingNumber: string;
}

export default function VCCConfirmationResendModal(props: Props) {
  const [errors, setErrors] = useState<string[] | undefined>(undefined);
  const { enqueueSnackbar } = useSnackbar();
  const resendVCCMutation = useResendVCCConfirmation();

  const handleConfirm = async () => {
    setErrors(undefined);

    try {
      await resendVCCMutation.mutateAsync({
        bookingNumber: props.bookingNumber,
      });
      enqueueSnackbar('VCC confirmation resent successfully', {
        variant: 'success',
      });
      props.hideModal();
    } catch (error) {
      const err = error as Error & { errors?: string[] };
      setErrors(err.errors || [err.message || 'Some Error Occurred']);
    }
  };

  return (
    <Dialog open={props.isModalVisible} onClose={props.hideModal}>
      <DialogTitle>Repush VCC</DialogTitle>

      <DialogContent>
        <DialogContentText>
          This action will repush VCC information to the property's reservations email address and property management
          system.
        </DialogContentText>

        {!!errors && (
          <Box mt={2}>
            <ErrorListDisplay errors={errors} />
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="text" onClick={props.hideModal}>
          Cancel
        </Button>
        <Button variant="contained" disabled={resendVCCMutation.isPending} onClick={handleConfirm}>
          {resendVCCMutation.isPending ? <Spinner size={15} inline={true} /> : 'Yes, continue'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
